export interface EstimateExpense {
  estimate: number;
  estimateWithTax: number;
  invoice: number;
  invoiceWithTax: number;
  purchase: number;
  purchaseWithTax: number;
}

export default class EstimateExpenseSummary {
  public estimates: EstimateExpense[];
  public invoices: EstimateExpense[];

  constructor() {
    this.estimates = [];
    this.invoices = [];
  }
}
